export class NFeEntradaFinanceiroExcluirRequest {
  justificativa = '';
}
